import PropTypes from 'prop-types';
import React from 'react';
import { formatNumber } from '../../../shared/formattingUtils';
import { formatGross } from '../utils/format';

const cards = (kpis) => [
  { label: 'Events', value: formatNumber(kpis.total_events || 0), icon: 'fal fa-calendar' },
  { label: 'Tickets sold', value: formatNumber(kpis.total_tickets_sold || 0) },
  { label: 'Gross (total collected)', value: formatGross(kpis.total_gross || 0) },
];

const KpiCards = ({ kpis, isMobile, loading, error }) => {
  const data = cards(kpis);
  const displayValue = (card) => {
    if (loading) return '…';
    if (error) return '—';
    return card.value;
  };

  if (isMobile) {
    return (
      <div className="tickets-kpi-strip-mobile">
        {data.map((card) => (
          <div key={card.label} className="tickets-kpi-strip-mobile-section">
            <div className="tickets-kpi-strip-mobile-label">{card.label}</div>
            <div className="tickets-kpi-strip-mobile-value">{displayValue(card)}</div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="tickets-kpi-grid">
      {data.map((card) => (
        <div key={card.label} className="tickets-kpi-card">
          <div className="tickets-kpi-card-header">
            {card.icon && <i className={card.icon} />}
            <span className="figma-text sm quaternary">{card.label}</span>
          </div>
          <div className="tickets-kpi-card-value">{displayValue(card)}</div>
        </div>
      ))}
    </div>
  );
};

KpiCards.propTypes = {
  kpis: PropTypes.shape({
    total_events: PropTypes.number,
    total_tickets_sold: PropTypes.number,
    total_gross: PropTypes.number,
  }).isRequired,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

KpiCards.defaultProps = {
  isMobile: false,
  loading: false,
  error: false,
};

export default KpiCards;
